module.exports = __webpack_public_path__ + "img/sanren.51916e05.png";